module.exports = __webpack_public_path__ + "img/BRCA3_Mono.Macro.46e8f0ae.png";